export enum IdTypes {
  sa,
  passport,
}
